<section class="mx-auto max-w-[1100px] px-6 py-9 sm:px-8 lg:px-0">
  <div class="mb-6 max-w-2xl">
    <div class="mb-3 flex h-1.5 w-[30px] gap-1">
      <span class="flex-1 rounded bg-(--cmr-vert)"></span>
      <span class="flex-1 rounded bg-(--cmr-rouge)"></span>
      <span class="flex-1 rounded bg-(--cmr-jaune)"></span>
    </div>
    <div class="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500">{{ 'pages.documentation.eyebrow' | translate }}</div>
    <h1 class="mt-2 text-3xl font-extrabold leading-tight text-(--text-body) sm:text-4xl">{{ 'pages.documentation.heroTitle' | translate }}</h1>
    <p class="mt-3 text-[14.5px] leading-relaxed text-(--text-muted)">
      {{ 'pages.documentation.heroSubtitle' | translate }}
    </p>
  </div>

  <form (submit)="onSubmit($event)" class="mb-4 flex flex-wrap gap-2.5" role="search">
    <input type="search" [formControl]="queryControl" placeholder="{{ 'pages.documentation.search' | translate }}…"
      aria-label="{{ 'pages.documentation.search' | translate }}"
      class="box-border h-11 min-w-0 flex-1 rounded-sm border border-(--border-input) bg-white px-3.5 text-[15px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)" />
    @if (categories().length > 0) {
      <select (change)="onCategoryChange($event)" [value]="categoryFilter()" [attr.aria-label]="'pages.documentation.filterByCategory' | translate"
        class="box-border h-11 rounded-sm border border-(--border-input) bg-white px-3.5 text-[14px] text-(--text-body) outline-none focus:border-(--brand-primary) focus:shadow-(--focus-ring)">
        <option value="">{{ 'pages.documentation.allCategories' | translate }}</option>
        @for (category of categories(); track category.code) {
          <option [value]="category.code">{{ category.name }}</option>
        }
      </select>
    }
    <button type="submit"
      class="box-border h-11 shrink-0 cursor-pointer rounded-sm border-0 bg-(--brand-primary) px-5 text-[14px] font-bold text-white transition hover:bg-(--brand-primary-hover)">
      {{ 'common.search' | translate }}
    </button>
  </form>

  @if (resourceTypeOptions().length > 1) {
    <div class="mb-6 flex flex-wrap gap-2">
      <button type="button" (click)="setResourceTypeFilter('')"
        class="inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-[13px] font-semibold transition"
        [class]="!resourceTypeFilter() ? 'border-(--brand-primary) bg-(--brand-primary) text-white' : 'border-(--border-strong) bg-white text-(--text-body) hover:bg-(--gris-050)'">
        {{ 'pages.documentation.allResourceTypes' | translate }}
      </button>
      @for (type of resourceTypeOptions(); track type) {
        <button type="button" (click)="setResourceTypeFilter(type)"
          class="inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-[13px] font-semibold transition"
          [class]="resourceTypeFilter() === type ? 'border-(--brand-primary) bg-(--brand-primary) text-white' : 'border-(--border-strong) bg-white text-(--text-body) hover:bg-(--gris-050)'">
          {{ resourceTypeLabel(type) }}
        </button>
      }
    </div>
  }

  @if (loading()) {
    <p class="py-12 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'pages.documentation.loading' | translate }}</p>
  } @else if (error()) {
    <p class="py-12 text-center text-[13.5px] text-(--state-danger)" role="alert">
      {{ 'pages.documentation.loadError' | translate }}
    </p>
  } @else if (filteredArticles().length > 0) {
    <div class="grid gap-4 sm:grid-cols-[repeat(auto-fill,minmax(280px,1fr))]">
      @for (article of filteredArticles(); track article.id; let i = $index) {
        <a [appScrollReveal]="i" [routerLink]="['/documentation', article.slug]"
          class="box-border flex flex-col gap-3 rounded-2xl border border-(--border-subtle) bg-white p-5 shadow-card transition hover:-translate-y-1 hover:shadow-(--shadow-raised)">
          <span class="inline-flex w-fit rounded-full bg-(--surface-primary-tint) px-3 py-1 text-[12.5px] font-bold text-(--pnud-bleu)">
            {{ resourceTypeLabel(article.resourceType) }}
          </span>
          <h2 class="m-0 text-[15.5px] font-extrabold leading-tight text-(--text-body)">{{ article.title }}</h2>
          @if (article.estimatedReadMinutes) {
            <span class="text-[12px] text-(--text-muted)">{{ article.estimatedReadMinutes }} {{ 'pages.documentation.readMinutesSuffix' | translate }}</span>
          }
        </a>
      }
    </div>
  } @else {
    <div class="box-border rounded-md border border-(--border-subtle) bg-white px-6 py-12 text-center">
      <p class="m-0 text-[14px] text-(--text-muted)">{{ 'pages.documentation.noResults' | translate }}</p>
    </div>
  }
</section>
